export const Source = { ADMIN: 1, WIDGET: 2 };
Object.freeze(Source);
